export default __webpack_public_path__ + "static/media/announcement.38d61965.svg";